import React from 'react';
import { FaSmileWink } from 'react-icons/fa'
import styles from './Projects.module.css';
import coinknight from '../../images/coinknight1.png';
import screenify from '../../images/screenify.png';
import vasiti from '../../images/vasiti.png';
import repo from '../../images/repo2.png';
import Modal from '../Modal/Modal';
import Aos from 'aos';
import 'aos/dist/aos.css';






const data = [
  {
    id: 0,
    image: coinknight,
    name: 'Crypto Tracker',
    description: "A cryptocurrency tracker that can be used to view the latest coins you just bought according to it's market cap. It also has a login/logout functionality where you can login and keep your coins in waitlist",
    url: 'https://coinknight.netlify.app',
    animate: 'fade-right'
  },
  {
    id: 1,
    image: screenify,
    name: 'A Trailer App',
    description: "A trailer web app where users can visit and see the trending movies at the moment it was accessed, It also has a feature where they can view the story beside the movie, and also the casts together with the roles they played",
    url: 'https://screenify.netlify.app',
    animate: 'fade-up'
  },
  {
    id: 2,
    image: vasiti,
    name: 'A Testimonial Website',
    description: "A Testimonial Website that allows users to make testimonies about the platform. Users can also see other people's testimonies and can access other features of the company from the site",
    url: 'https://vasiti-site.netlify.app',
    animate: 'fade-up'
  },
  {
    id: 3,
    image: repo,
    name: 'Popular Repositories',
    description: "A web app that displays the current trending repositories on Github, it also shows the number of forks and viewers they have... The language used on the project is also gotten from the web app",
    url: 'https://popular-git-repos.netlify.app',
    animate: 'fade-up'
  },
];


const elements = data.map(each => {
  return (
    <div className={styles.item} data-aos={each.animate}>
      <img src={each.image} />
      <span> {each.name} </span>
      <Modal 
        image = {each.image} 
        name = {each.name}
        description = {each.description}
        url = {each.url} />
    </div>
  )
})







export default function Project () {

  React.useEffect(() => {
    Aos.init({duration: 1200})
  }, [])


  return (
    <div className={styles.container}>
      <h2 data-aos='fade-right'> ...Impressed? 😊 </h2>
      <p data-aos='fade-right'> Here are some of my works... </p>
      <div className={styles.box}>
        { 
          elements
        }
      </div>
        <i> <a href="https://github.com/ezelu" target="_blank"> See more on Github...</a> </i>
    </div>
  )
}